import { create } from 'zustand'

/**
 * Builder Mode UI context shared with the Ask-AI dock.
 *
 * Tracks the object the user currently has open from the navigation (the live
 * preview's selected screen). The dock reads this when sending a chat message
 * so the agent can resolve deictic references like "this" / "here" / "this
 * form" to the open object instead of guessing.
 */

export interface OpenObject {
  obj_name: string
  obj_type: string
  title: string
}

interface BuilderContextState {
  openObject: OpenObject | null
  setOpenObject: (obj: OpenObject | null) => void
}

export const useBuilderContextStore = create<BuilderContextState>((set) => ({
  openObject: null,
  setOpenObject: (obj) => set({ openObject: obj }),
}))
